<template>
  <div class="flex flex-col text-white items-center">
    <div class="h-20"></div>
    <svg viewBox="0 0 20 20" fill="currentColor" class="check-circle w-32 h-32">
      <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
    </svg>
    <div class="text-teal-100 text-sm">Su contraseña se ha cambiado correctamente</div>
    <div><button @click="inicio" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Inicio</button></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      codigo: ""
    };
  },
  methods: {
    inicio() {
      this.$router.push("/");
    }
  }
};
</script>
